import { Component } from '@angular/core';

@Component({
  selector: 'dt-myfavorite-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  title = 'DT.AN.MyFavorite';
  
  constructor() {
     console.log('**** MyFavorite - ANGULAR 19 IS RUNNING ****');
  }
}
